import { apiClient } from "../Utilities/apiClient";

export interface OnboardingAnswer {
    id: number;
    text: string;
}

export interface OnboardingQuestion {
    id: number;
    text: string;
    isMultiple: boolean;
    isActive: boolean;
    answers: OnboardingAnswer[];
}

export const onboardingService = {
    getQuestions: () => apiClient.get('/onboarding/questions/admin'),
    updateQuestion: (id: number, data: Partial<OnboardingQuestion>) => apiClient.put(`/onboarding/questions/${id}`, data),
    createQuestion: (data: { text: string; isMultiple: boolean }) => apiClient.post('/onboarding/questions', data),
    createAnswers: (data: { answers: { question: number; answers: { text: string }[] }[] }) => apiClient.post('/onboarding/answers', data)
};
